/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'team-central.give-jira-kudos.created.description.flag': 'Vårt team för arbetsplatserfarenhet fixar din gåvoförfrågan. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Beröm skapat',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'Vi kunde inte skapa dina beröm eller skicka gåvan. Försök att skapa ett separat ärende på <a>go/kudos</a>.',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'Något gick fel',
  'team-central.give-kudos.button': 'Ge beröm',
  'team-central.give-kudos.close-button.label': 'Stäng låda',
  'team-central.give-kudos.confirm-close.title': 'Bekräfta att du vill avsluta',
  'team-central.give-kudos.created.description.flag': 'Ditt beröm har skickats. <a>Visa beröm</a>',
  'team-central.give-kudos.created.title.flag': 'Beröm skapat',
  'team-central.give-kudos.creation.failed.description.flag': 'Vi kunde inte skapa dina beröm.',
  'team-central.give-kudos.creation.failed.title.flag': 'Något gick fel',
  'team-central.give-kudos.error-icon.label': 'Fel',
  'team-central.give-kudos.success-icon.label': 'Klart!',
  'team-central.give-kudos.unsaved.warning': 'Dina ändringar sparas inte.',
  'team-central.give-kudos.unsaved.warning.cancel': 'Avbryt',
  'team-central.give-kudos.unsaved.warning.close': 'Stäng'
};